import type { SessionStepModule } from '../types';
import { IdVerificationDetail } from './IdVerificationDetail';
import { IdVerificationStepRunner } from './IdVerificationStepRunner';
import { isIdStep } from './id.utils';

// Combined ID Verification step module (Voter ID / Passport / Driving Licence).
export const idStepModule: SessionStepModule = {
  key: 'id',
  matches: isIdStep,
  Runner: IdVerificationStepRunner,
  Detail: IdVerificationDetail,
};
